const coinAudio = new Audio('/sounds/coins.mp3');

export function playCoinSound(): void {
    coinAudio.play();
}
